var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.size)?_c('main-canvas',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"width":_vm.size.width,"height":_vm.size.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }